import { render, staticRenderFns } from "./BuildCard.vue?vue&type=template&id=efc61fe2&scoped=true&"
import script from "./BuildCard.vue?vue&type=script&lang=js&"
export * from "./BuildCard.vue?vue&type=script&lang=js&"
import style0 from "./BuildCard.vue?vue&type=style&index=0&id=efc61fe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc61fe2",
  null
  
)

export default component.exports